module.exports = __webpack_public_path__ + "img/perdio-sesion.7c33fac2.svg";